import { Box, IconButton, Tooltip } from "@mui/material";
import { grey } from "@mui/material/colors";

interface Props {
  hasSentEmails?: boolean;
  onDelete: () => void;
}

// Trash button for archived rows. An archived campaign that already sent emails
// can't be deleted (it can only stay archived), so it's disabled with a tooltip.
export default function CampaignDeleteButton({
  hasSentEmails,
  onDelete,
}: Props) {
  if (hasSentEmails) {
    return (
      <Tooltip
        title="Campaigns that have sent emails can't be deleted."
        placement="top"
      >
        <Box component="span">
          <IconButton
            size="small"
            disabled
            sx={{ flexShrink: 0, color: grey[300] }}
          >
            <Box
              component="i"
              className="fa-regular fa-trash"
              sx={{ fontSize: 14 }}
            />
          </IconButton>
        </Box>
      </Tooltip>
    );
  }
  return (
    <IconButton
      size="small"
      onClick={(e) => {
        e.stopPropagation();
        onDelete();
      }}
      sx={{
        flexShrink: 0,
        color: grey[400],
        "&:hover": { color: "error.main" },
      }}
    >
      <Box
        component="i"
        className="fa-regular fa-trash"
        sx={{ fontSize: 14 }}
      />
    </IconButton>
  );
}
